import { SlideAction, SlideLayout, ViewMode } from '@gripp/shared-ui';
import { ActivityEditColumn } from './activityEditColumn';
import { ActivityReviseColumn } from './activityReviseColumn';

export const ActivityRevise = () => {
  const leftColumn = {
    title: 'issue.menu.edit',
    mainComponent: <ActivityEditColumn />,
    showBackButton: true,
    backButtonTransition: SlideAction.PREV,
    disableScroll: true,
  };

  const rightColumn = {
    title: 'issue.editModal.reviseSubmission',
    mainComponent: <ActivityReviseColumn />,
    showBackButton: true,
    backButtonTransition: SlideAction.PREV,
    disableScroll: true,
  };

  return (
    <SlideLayout
      leftColumn={leftColumn}
      rightColumn={rightColumn}
      viewMode={ViewMode.DUAL}
    />
  );
};
